import { createMemo, from } from "solid-js";
import { A } from "@solidjs/router";

import { WifiNetwork } from "../../../casts/wifi-network";
import { location$ } from "../../../services/location";
import { calculateDistance, getMapUrl } from "../../../helpers/geohash";
import { MapIcon } from "../../../components/icons";

export default function NetworkCard(props: { network: WifiNetwork }) {
  const location = from(location$);

  const ssid = props.network.ssid;
  const name = props.network.name;
  const security = props.network.security || "unknown";
  const captive = props.network.captive ? "true" : "false";

  // Calculate distance
  const distance = createMemo(() => {
    const user = location();
    const networkLocation = props.network.location;
    if (!networkLocation || !user) return null;

    return calculateDistance(
      user.coords.latitude,
      user.coords.longitude,
      networkLocation.lat,
      networkLocation.lng,
    );
  });

  // Format distance in miles (converting from kilometers)
  const formattedDistance = createMemo(() => {
    const dist = distance();
    if (dist === null) return "Unknown distance";
    // Convert km to miles (1 km = 0.621371 miles)
    const miles = dist * 0.621371;
    return `${miles.toFixed(2)} miles away`;
  });

  // Get map URL
  const mapUrl = createMemo(() => getMapUrl(props.network.event));

  return (
    <div class="card bg-base-100 shadow relative">
      <div class="card-body p-4">
        <A
          href={props.network.naddr ? `/wifi/${props.network.naddr}` : "#"}
          class="btn btn-primary btn-sm absolute right-4 top-4"
        >
          View
        </A>
        <h3 class="card-title pr-16">{name || ssid}</h3>
        <p class="text-sm text-base-content/70">Security: {security}</p>
        <p class="text-sm text-base-content/70">Captive: {captive}</p>
        <p class="text-sm text-base-content/70">{formattedDistance()}</p>
        {mapUrl() && (
          <a
            href={mapUrl()!}
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-ghost btn-primary btn-square btn-sm absolute bottom-4 right-4"
            aria-label="Open in Maps"
          >
            <MapIcon />
          </a>
        )}
      </div>
    </div>
  );
}
